import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { NavigationBar, ProfileMenu } from '@barracuda-internal/bds-core';
import {
  Apartment,
  Assignment,
  Dashboard,
  Dns,
  InfoOutlined,
  LogOut,
  Search,
  Storage,
  UserGroup,
} from '@barracuda-internal/bds-core/dist/Icons/Core';
import SvgFaviconApp from '@barracuda-internal/bds-core/dist/Logos/Favicons/FaviconApp';

import { actions as authActions } from '../login/authReducer';

const generateInitials = (name) => {
  if (!name) return '?';
  const parts = name.split(/[\s@.]/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
};

// Support-dashboard nav: same shape as guardian's admin nav (icons +
// labels), gated by role. Every ADMIN/OPS/SUPPORT session sees the full
// nav in v1; write actions inside each page are role-gated via
// AADRoleGuard.
const NAV_ROUTES = [
  { path: '/global/dashboard', icon: <Dashboard />, name: 'Dashboard' },
  { path: '/global/accounts',  icon: <Apartment />, name: 'Accounts' },
  { path: '/global/users',     icon: <UserGroup />, name: 'Users' },
  { path: '/global/backends',  icon: <Storage />,   name: 'Backends' },
  { path: '/global/gateways',  icon: <Dns />,       name: 'Gateways' },
  { path: '/global/audit',     icon: <Assignment />, name: 'Audit log' },
  { path: '/global/scans',     icon: <Search />,    name: 'Scan lookup' },
];

const NavigationPanel = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const username = useSelector((s) => s.auth.username) || '';
  const roles = useSelector((s) => s.auth.roles) || [];

  const handleLogout = () => {
    dispatch(authActions.logout());
  };

  const initials = generateInitials(username);
  const rolesLabel = roles.length ? roles.join(', ') : 'Support';

  return (
    <NavigationBar
      title="Prompt Security"
      logo={<SvgFaviconApp />}
      options={[
        {
          name: 'Profile',
          initials,
          menu: (
            <ProfileMenu
              initials={initials}
              name={username || 'Support user'}
              email={username}
              menuItems={[
                {
                  name: 'Privacy Policy',
                  href: 'https://www.barracuda.com/legal/privacy',
                  openInNewTab: true,
                  icon: <InfoOutlined />,
                },
                {
                  name: 'Sign Out',
                  onClick: handleLogout,
                  icon: <LogOut />,
                },
              ]}
              footer={{ serial: rolesLabel, version: 'Support v1' }}
            />
          ),
        },
      ]}
      routes={NAV_ROUTES}
      currentPath={location.pathname}
      onNavigate={(path) => history.push(path)}
    />
  );
};

export default NavigationPanel;
